import { ChevronRight } from "lucide-react";

export default function SectionHead({ title, icon: Icon, onSee, seeLabel = "See All", seeTestid }) {
  return (
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-lg font-bold font-display pv-text-dark flex items-center gap-2">
        {Icon && <Icon size={18} className="pv-text-dark" />}
        {title}
      </h2>
      {onSee && (
        <button data-testid={seeTestid} onClick={onSee} className="text-xs font-bold text-[#4A90E2] inline-flex items-center gap-0.5 hover:underline">
          {seeLabel}<ChevronRight size={14} />
        </button>
      )}
    </div>
  );
}
